import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Escape HTML entities to prevent XSS attacks
 *
 * SECURITY: Use this when inserting user content into HTML context
 * outside of React's JSX (which auto-escapes). Required for:
 * - dangerouslySetInnerHTML with user content
 * - String concatenation that will be rendered as HTML
 */
export function escapeHtml(unsafe: string): string {
  return unsafe
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}
